import LeaderCard from "./LeaderCard";
import kirenImg from "../../../../assets/pages/landing/leaders/kiren.png";
import abhaImg from "../../../../assets/pages/landing/leaders/abha.png";
import LeadershipBackgroud from "../../../../assets/pages/landing/leaders/LeadershipBackgroud.png";
import cmdprofilepdf from "../../../../assets/Leadership_pdf/cmdprofilepdf.pdf";
import { ReservedLeaderSlot } from "./Leadership.styles";
const leaders = [
  {
    image: kirenImg,
    name: "SHRI KIREN RIJIJU",
    designation: "Honorable Union Minister For Minority Affairs",
  },

  {
    image: abhaImg,
    name: "DR. ABHA RANI SINGH, IRS",
    designation: "Chairman-Cum-Managing Director, NMDFC",
    profilePdf: cmdprofilepdf
  },
];

const LeadershipSection = () => {
  const reservedLeaderSlots = Math.max(0, 3 - leaders.length);

  return (
    <section className="bg-white border border-[#00585699] shadow-md rounded-2xl flex justify-center h-full min-w-0 overflow-hidden">
      <div
        className="grid grid-cols-1 content-around gap-8 w-full min-w-0 h-full p-5 max-[1100px]:grid-cols-2 max-[680px]:grid-cols-1"
        style={{
          backgroundImage: `url(${LeadershipBackgroud})`,
          backgroundSize: "130% auto",
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="flex flex-col gap-2 items-center max-[1100px]:col-span-2 max-[680px]:col-span-1">
          <h2 className="font-semibold text-center text-[#005856] text-[clamp(24px,3vw,30px)]">
            Our Leadership
          </h2>
          <div className="bg-[#f3b31c] h-2 w-16 rounded-md"></div>
        </div>
        {leaders.map((leader) => <LeaderCard key={leader.name} {...leader} />)}
        {Array.from({ length: reservedLeaderSlots }, (_, index) => (
          <ReservedLeaderSlot
            key={`reserved-leader-${index}`}
            aria-hidden="true"
          />
        ))}
      </div>
    </section>
  );
};

export default LeadershipSection;
